import { ID } from 'api'
import { CallbackTestResult } from 'api/callback-url/types'

type CallbackUrl = CallbackTestResult & { applicationId: ID }

export const testCallBackUrls: CallbackUrl[] = [
  {
    applicationId: '1',
    message: 'all fine here',
    success: true,
  },
  {
    applicationId: '2',
    message: 'refused to check this URL',
    success: false,
  },
]
